import { render, staticRenderFns } from "./Trades.vue?vue&type=template&id=13b63e5e&scoped=true&"
import script from "./Trades.vue?vue&type=script&lang=js&"
export * from "./Trades.vue?vue&type=script&lang=js&"
import style0 from "./Trades.vue?vue&type=style&index=0&id=13b63e5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b63e5e",
  null
  
)

export default component.exports